var race = function(promises){
    
    var resolved;
    
    return new Promise(function(resolve, reject){
        promises.forEach(function(promise){
            promise.then(function(value){
                return resolve(value);
            })
        })
    })
}

export default race;


//////////////////
// WEBPACK FOOTER
// ./src/utils/custom-race.js
// module id = 14
// module chunks = 0